import { gql } from "@apollo/client";

export default gql`
  query getAiAnswerExplanation($messageId: ID!){
    getAiAnswerExplanation(messageId: $messageId){
        success
        data{
            runId
            groupedIntoRunId
            engineVersion
            surface
            outcome
            reason
            agentAction
            confidence
            handoffReason
            agentNote
            knowledgeGap
            knowledgeSearches{
                query
                status
                hits
            }
            complianceViolations{
                code
                surface
            }
            roleName
            role
            activeSkill
            handoffDisabled
            handedOff
            dmSent
            hasCitations
            suggestions{
                code
                targetId
                question
            }
            sources{
                id
                knowledgeSourceContentId
                content
                subTopic
                topic
                request
                response
                order
                type
                group
                cited
            }
            durationMs
        }
        code
        message
    }
}
`
